import { CameraStatuses, HvsEntity } from "lib/api";

export class CameraUtils {
  public static getStatus(camera?: HvsEntity): CameraStatuses {
    if (!camera) {
      return CameraStatuses.StatusNotAvailable;
    }
    if (
      camera.attributes &&
      camera.attributes.is_gateway_active &&
      camera.attributes.is_gateway_active.value === false
    ) {
      return CameraStatuses.GatewayOffline;
    }
    if (
      !camera.attributes ||
      (camera.attributes && !camera.attributes.active)
    ) {
      return CameraStatuses.StatusNotAvailable;
    }
    if (
      camera.attributes &&
      camera.attributes.is_detached &&
      camera.attributes.is_detached.value === true
    ) {
      return CameraStatuses.CameraNoLongerExist;
    }
    const isOnline =
      camera.attributes &&
      camera.attributes.active &&
      camera.attributes.active.value === true;
    return isOnline
      ? CameraStatuses.CameraOnline
      : CameraStatuses.CameraOffline;
  }
}
